<template>
    <div class="mt-[20px]">
        <div class="grid grid-cols-2 gap-2 h-[47px]">
            <div class="inline-flex w-full">
                <DropDown 
                    v-if="dropDownOptions.length > 0" 
                    v-model="mutiplsOptions.value"
                    :options="dropDownOptions" 
                    @update:model-value="emit('update:stoneNum', Number($event))" 
                    class="h-[48px] w-full"
                    :disabled="optionDisabled || isSubmiting"
                >
                    <template #prevIcon>
                        <span class="text-sm font-semibold text-[#55657e]">
                            {{ $t('StonesNumber') }}:
                        </span>
                    </template>
                </DropDown>
            </div>

            <div class="grid gap-2">
                <button
                    @click="autoPickFunction"
                    class="bg-[#ffb636] h-full w-full border-[#ffb636] font-bold rounded-md text-black select-none text-base btn-yellow"
                    :disabled="autoDisabled"
                >
                    {{ t.GameTower.AutoPick }}
                </button>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import useTranslation from '~/i18n/useTransLation';
import { roundData, dropDownOptions } from '../data';

const props = defineProps({
    stoneNum: {
        type: Number,
        required: true,
    },
    optionDisabled: {
        type: Boolean,
        required: true,
    },
    isSubmiting: {
        type: Boolean,
        required: true,
    },
    round: {
        type: Object as PropType<typeof roundData>,
        required: true,
    },
    autoPickFunction: {
        type: Function,
        required: true,
    },
    autoDisabled: {
        type: Boolean,
        required: true,
    },
    stoneOptions: {
        type: Object,
        required: true,
    },
});

const t = useTranslation();

const emit = defineEmits(['update:stoneNum', 'update:round']);

const mutiplsOptions = computed(() => {
    return {
        value: props.stoneNum,
        options: Object.keys(props.stoneOptions),
    };
});

</script>

<style lang="scss" scoped>
.btn {
    background-color: #161f2c;
    border: 1px solid rgba(85, 101, 126, 0.28);
    border-radius: 10px;
    box-sizing: border-box;
    color: #55657e;
    display: block;
    font-size: 16px;
    font-weight: 600;
    height: 100%;
    left: 20px;
    line-height: 45px;
    margin-right: 2px;
    text-align: center;
    transition: all 0.3s;
    margin-left: 2px;
    flex: 1;
    &:last-child{
        margin-right: 0;
    }
    &:first-of-type {
        margin-left: 0;
    }
}
.btnCurrent {
    border: 1px solid #297fe5;
    border-radius: 10px;
    box-sizing: border-box;
    color: #fff;
    display: block;
    font-size: 16px;
    font-weight: 600;
    height: 100%;
    left: 20px;
    line-height: 45px;
    margin-right: 2px;
    margin-left: 2px;
    text-align: center;
    transition: all 0.3s;
    background-color: #297fe5;
}
.btn-yellow {
    border-width: 1px;
    &:hover:not(:disabled) {
        box-shadow: 0 14px 20px #ffbc004d;
        background-color: #ffc31a;
    }
    &:disabled {
        background-color: #cc9600;
        opacity: .75;
        pointer-events: none;
    }
}
</style>
